import { createFileRoute, redirect } from '@tanstack/react-router'

import { Tag } from '@masterplandev/ui'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_GROWTH_MAP } from '@/core/constants/features'
import { skillsKeys } from '@/growth-map/queries/queryKeys'
import { skills } from '@/http/api/skills'
import { TopicPage } from '@/topic/components/TopicPage/TopicPage'
import { TopicPageContent } from '@/topic/components/TopicPageContent/TopicPageContent'

export const Route = createFileRoute('/_learning/skill/$skill/$topic/')({
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_GROWTH_MAP)) {
      throw redirect({ to: '/home' })
    }
  },
  loader: async ({ context: { queryClient }, params }) => {
    const skillDetails = await queryClient.ensureQueryData({
      queryKey: skillsKeys.details(params.skill),
      queryFn: () => skills.details({ params: { skillSlug: params.skill } }),
    })
    return { skillDetails }
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator size="xl" />,
})

function RouteComponent() {
  const { skillDetails } = Route.useLoaderData()
  const params = Route.useParams()

  return (
    <TopicPage>
      <TopicPageContent
        context="skill"
        extraInfo={
          <Tag variant="outline" mb="4" size="lg">
            {skillDetails.name}
          </Tag>
        }
        skillSlug={params.skill}
        topicSlug={params.topic}
      />
    </TopicPage>
  )
}
